import { recordActivity } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";

export const RecordDetailsOfPolice = {
  mixins: [],
  data() {
    return {
      Police_Details_Record: [],
      overlay: false,
    };
  },
  methods: {
    async RecordDetailsOfPoliceMethod() {
      let CompleteDetailsObject = this.$store.getters.get_complete_data;

      try {
        this.overlay = true;
        var inputParams = {
          police_id: this.$store.getters.get_current_user_details.user_id,
          motorist_id: this.$store.getters.get_car_details.user_id,
          activity_type:
            CompleteDetailsObject.ViolationSentName !== undefined
              ? "BOTH"
              : "PROFILE_ACCESS_REQUEST",
          state: "pennyslvania",
          start_time: CompleteDetailsObject.StartDate,
          // start_time: 1732257967000,
          start_location: CompleteDetailsObject.StartLocation,
          end_time: CompleteDetailsObject.EndTime,
          // end_time: 1732258577000,
          end_location: CompleteDetailsObject.EndLocation,
          // city: this.$store.getters.get_current_user_details.police_city
          //   .replaceAll(" ", "_")
          //   .toLowerCase(),
          city: "pittsburgh",
          // precinct: this.$store.getters.get_current_user_details.precinct
          //   .replaceAll(" ", "_")
          //   .toLowerCase(),
          // precinct: "greenfield",
          zone: this.$store.getters.get_current_user_details.police_zone,
          // zone: "zone_1",
          violation_sent:
            CompleteDetailsObject.ViolationSentName != undefined
              ? CompleteDetailsObject.ViolationSentName
              : undefined,

          total_duration: CompleteDetailsObject.TotalDuration,
        };
        let result = await API.graphql(
          graphqlOperation(recordActivity, {
            input: inputParams,
          })
        );
        console.log("maara", result);
        // this.Police_Details_Record = JSON.parse(result.data.recordActivity);
        this.$store.commit("SET_COMPLETE_DATA", {});
        this.overlay = false;
      } catch (error) {
        console.log("Check error", error);
        this.overlay = false;
      }
    },
  },
};
